import { cn } from '@/lib/utils';
import linkLogo from '@/assets/link-logo-clean.png';

interface LinkLogoProps {
  className?: string;
  iconClassName?: string;
  showText?: boolean;
  showDomain?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  layout?: 'horizontal' | 'vertical';
}

export function LinkLogo({
  className,
  iconClassName,
  showText = true,
  showDomain = false,
  size = 'md',
  layout = 'horizontal'
}: LinkLogoProps) {
  const heightClass = {
    sm: 'h-10',
    md: 'h-12',
    lg: 'h-14',
    xl: 'h-16',
  };

  const domainSize = {
    sm: 'text-[10px]',
    md: 'text-xs',
    lg: 'text-sm',
    xl: 'text-base',
  };

  const isVertical = layout === 'vertical';

  return (
    <div className={cn(
      'flex items-center',
      isVertical ? 'flex-col gap-2' : 'gap-2.5',
      className
    )}>
      <img
        src={linkLogo}
        alt="LINK logo"
        className={cn(heightClass[size], 'w-auto', iconClassName)}
      />

      {showDomain && (
        <span className={cn('text-muted-foreground', domainSize[size])}>
          linkmedicalai.com
        </span>
      )}
    </div>
  );
}
